var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMilestoneRankBg = function SvgMilestoneRankBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_2202)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "var(--on-accent)",
    stroke: "var(--accent)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4976 32.3129L64.4963 32.4948C64.4987 32.3302 64.5 32.1652 64.5 32C64.5 31.8348 64.4987 31.6698 64.4963 31.5052L52.4976 31.6871C52.4992 31.7912 52.5 31.8955 52.5 32C52.5 32.1045 52.4992 32.2088 52.4976 32.3129Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.673 42.2571C49.7783 42.0812 49.881 41.9035 49.981 41.7242L60.4611 47.574C60.3008 47.8611 60.1363 48.1454 59.9675 48.427L49.673 42.2571Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2242 49.481C42.4035 49.381 42.5812 49.2783 42.7571 49.173L48.927 59.4675C48.6454 59.6363 48.3611 59.8008 48.074 59.9611L42.2242 49.481Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1871 51.9976C32.2912 51.9992 32.3955 52 32.5 52C32.6045 52 32.7088 51.9992 32.8129 51.9976L32.9948 63.9963C32.8302 63.9987 32.6652 64 32.5 64C32.3348 64 32.1698 63.9987 32.0052 63.9963L32.1871 51.9976Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2429 49.173C22.4188 49.2783 22.5965 49.381 22.7758 49.481L16.9261 59.9611C16.6389 59.8008 16.3546 59.6363 16.073 59.4675L22.2429 49.173Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.019 41.7242C15.119 41.9035 15.2217 42.0812 15.327 42.2571L5.03248 48.427C4.86372 48.1454 4.69917 47.8611 4.53892 47.574L15.019 41.7242Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5024 31.6871C12.5008 31.7912 12.5 31.8955 12.5 32C12.5 32.1045 12.5008 32.2088 12.5024 32.3129L0.503748 32.4948C0.501252 32.3302 0.5 32.1652 0.5 32C0.5 31.8348 0.501252 31.6698 0.503748 31.5052L12.5024 31.6871Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.327 21.7429C15.2217 21.9188 15.119 22.0965 15.019 22.2758L4.53891 16.426C4.69917 16.1389 4.86372 15.8546 5.03247 15.573L15.327 21.7429Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7758 14.519C22.5965 14.619 22.4188 14.7217 22.2429 14.827L16.073 4.53247C16.3546 4.36372 16.6389 4.19917 16.926 4.03892L22.7758 14.519Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8129 12.0024C32.7088 12.0008 32.6045 12 32.5 12C32.3955 12 32.2912 12.0008 32.1871 12.0024L32.0052 0.00374795C32.1698 0.00125231 32.3348 0 32.5 0C32.6652 0 32.8302 0.0012523 32.9948 0.00374793L32.8129 12.0024Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7571 14.8269C42.5812 14.7217 42.4035 14.619 42.2242 14.519L48.074 4.03891C48.3611 4.19917 48.6454 4.36372 48.927 4.53247L42.7571 14.8269Z",
    fill: "var(--accent)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.673 21.7429L59.9675 15.573C60.1363 15.8546 60.3008 16.1389 60.4611 16.426L49.981 22.2758C49.881 22.0965 49.7783 21.9188 49.673 21.7429Z",
    fill: "var(--accent)"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_2202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
};
export default SvgMilestoneRankBg;